import { useState, useEffect, ReactElement } from 'react'

const useDelayedRender = (delay: number) => {
  const [delayed, setDelayed] = useState(true)

  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delay)
    return () => clearTimeout(timeout)
  }, [delay])

  return (fn: Function) => !delayed && fn()
}

type DelayedRenderProps = {
  /** Number of milliseconds before children should be rendered */
  delay: number
  /** Components whose render should be delayed */
  children: ReactElement
}

const DelayedRender = ({ delay, children }: DelayedRenderProps) =>
  useDelayedRender(delay)(() => children)

export default DelayedRender
